import config from "config/config";
import { useAppStore } from "store/store";

export interface DemoScenario {
  fileName: string;
  fileContentBase64: string;
}

const mockFile =
  "data:image/jpeg;base64,/9j/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAEBAREA/8QAFAABAAAAAAAAAAAAAAAAAAAAA//EABQQAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQEAAD8AN//Z";

const scenarios: { [key: string]: { [docType: string]: DemoScenario } } = {
  guillermo: {
    PASSPORT: {
      fileName: "guillermo_passport.jpg",
      fileContentBase64: mockFile,
    },
    TRAVEL_DOC: {
      fileName: "guillermo_passport.jpg",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-USA": {
      fileName: "guillermo_green_card.jpg",
      fileContentBase64: mockFile,
    },
  },
  gondwe: {
    PASSPORT: {
      fileName: "gondwe_passport.png",
      fileContentBase64: mockFile,
    },
    TRAVEL_DOC: {
      fileName: "gondwe_passport.png",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-SCHENGEN": {
      fileName: "gondwe_poland_rp_back.jpg",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-EU": {
      fileName: "gondwe_poland_rp_back.jpg",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-EU,EEA,SCHENGEN": {
      fileName: "gondwe_poland_rp_back.jpg",
      fileContentBase64: mockFile,
    },
    "TRAVELER_DECLARATION-COL": {
      fileName: "gondwe_checkmig.pdf",
      fileContentBase64: mockFile,
    },
    "TRAVELER_DECLARATION-HND": {
      fileName: "gondwe_hnd_declaration.pdf",
      fileContentBase64: mockFile,
    },
    "TRAVELER_DECLARATION-DOM": {
      fileName: "gondwe_dom_declaration.pdf",
      fileContentBase64: mockFile,
    },
    IND_EVISA: {
      fileName: "gondwe_ind_evisa.pdf",
      fileContentBase64: mockFile,
    },
    "EVISA-IND": {
      fileName: "gondwe_ind_evisa.pdf",
      fileContentBase64: mockFile,
    },
  },
  agarwal: {
    PASSPORT: {
      fileName: "agarwal_passport.png",
      fileContentBase64: mockFile,
    },
    TRAVEL_DOC: {
      fileName: "agarwal_passport.png",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-SCHENGEN": {
      fileName: "agarwal_poland_rp_back.png",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-EU": {
      fileName: "agarwal_poland_rp_back.png",
      fileContentBase64: mockFile,
    },
    "RESIDENCE_PERMIT-EU,EEA,SCHENGEN": {
      fileName: "agarwal_poland_rp_back.png",
      fileContentBase64: mockFile,
    },
    "VISA_OR_EVISA-VNM": {
      fileName: "agarwal_vnm_evisa.pdf",
      fileContentBase64: mockFile,
    },
    "EVISA-VNM": {
      fileName: "agarwal_vnm_evisa.pdf",
      fileContentBase64: mockFile,
    },
  },
  alex: {
    PASSPORT: {
      fileName: "alex_passport.png",
      fileContentBase64: mockFile,
    },
    TRAVEL_DOC: {
      fileName: "alex_passport.png",
      fileContentBase64: mockFile,
    },
    "TRAVELER_DECLARATION-DOM": {
      fileName: "alex_dom_declaration.pdf",
      fileContentBase64: mockFile,
    },
    USA_EMBASSY_VISA: {
      fileName: "alex_usa_visa.png",
      fileContentBase64: mockFile,
    },
    "VISA-USA": {
      fileName: "alex_usa_visa.png",
      fileContentBase64: mockFile,
    },
    "EMBASSY_VISA-USA": {
      fileName: "alex_usa_visa.png",
      fileContentBase64: mockFile,
    },
  },
};

const useDemoScenario = (itemType: string): DemoScenario | undefined => {
  const demoScenarioName = useAppStore((state) => state.demoScenario);
  if (
    config.demoMode &&
    demoScenarioName !== undefined &&
    scenarios[demoScenarioName] !== undefined &&
    scenarios[demoScenarioName][itemType] !== undefined
  ) {
    return scenarios[demoScenarioName][itemType];
  }

  return undefined;
};

export default useDemoScenario;
